import Callout from '@passkeys/ui/callout';

interface ValidationProps {
  error?: string;
  warning?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

function SendValidation({ error, warning, action }: ValidationProps) {
  return (
    <>
      {error && (
        <Callout type="error" action={action}>
          {error}
        </Callout>
      )}

      {!error && warning && (
        <Callout type="warning" action={action}>
          {warning}
        </Callout>
      )}
    </>
  );
}

export default SendValidation;
